module.exports = __webpack_public_path__ + "static/img/map_600.271e6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/map_600.png
// module id = j2Qx
// module chunks = 0